import { render, staticRenderFns } from "./purchase_supplier_edit.vue?vue&type=template&id=475a0f0a&scoped=true"
import script from "./purchase_supplier_edit.vue?vue&type=script&lang=js"
export * from "./purchase_supplier_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a0f0a",
  null
  
)

export default component.exports